import { defineStore } from 'pinia';
import { Permission } from './permissions';
import { Role } from './roles';
import { snakeCase } from 'lodash';

export const usePermissionStore = defineStore({
  id: 'permission',

  state: () => ({
    permissions: [] as Permission[],
    roles: [] as Role[],
  }),

  actions: {
    setCurrentPermissions(permissions: Permission[]): void {
      this.permissions = permissions;
    },
    setCurrentRoles(roles: Role[]): void {
      this.roles = roles.map<Role>((role) => snakeCase(role) as Role);
    },
  },
});
